export const EventTypes = {
  STORE_CHANGED: "store-changed",
  DELIVERY_ADDRESS_UPDATED: "delivery-address-updated",
  DELIVERY_TYPE_UPDATED: "delivery-type-updated",
  DELIVERY_MODE_UPDATED: "delivery-mode-updated",
};
